import {
    ExperienceResponseAvailabilityTypeEnum
} from "@bookingkit/api-v4/models/experience-response";
import {EXPERIENCE, Experience, ExperienceOption} from "../types";
import ExperienceServiceError from "../Errors/ExperienceServiceError";
import {WidgetExperienceResponse} from "@bookingkit/api-v4";


export const mapExperience = (experience: WidgetExperienceResponse):Experience => {
    const {id, title, description, cover_image, availability_type, latest_booking_time_minutes,
           requires_vendor_confirmation, location, booking_restrictions} = experience;
    if (id === undefined) {
        throw ExperienceServiceError.fromMissingProperty('id', 'string', id);
    }
    if (availability_type === undefined) {
        throw ExperienceServiceError.fromMissingProperty('availability_type', 'string', availability_type);
    }
    if (title === undefined) {
        throw ExperienceServiceError.fromMissingProperty('title', 'string', title);
    }
    if (location === undefined) {
        throw ExperienceServiceError.fromMissingProperty('location', 'object', location);
    }
    if (availability_type !== ExperienceResponseAvailabilityTypeEnum.OpeningHours && availability_type !== ExperienceResponseAvailabilityTypeEnum.TimeSlot) {
        throw ExperienceServiceError.fromInvalidProperty('availability_type', availability_type);
    }
    const getOptions = (): ExperienceOption[] => {
        if(!experience.options || experience.options?.length < 1) {
            throw new Error('Experience has no options');
        }
        return experience.options.map((option) => {
                return {
                    id: option.id || '',
                    title: option.title || '',
                    durationInMinutes: option.duration_in_minutes || 0,
                    restrictions:  {
                        cutoffBeforeBegin: option.restrictions?.cutoff_before_begin ?? 0,
                        cutoffBeforeEnd: option.restrictions?.cutoff_before_end  ?? 0,
                    }
                }
            });
        }

    const getTranslations = ():{ locale: string; properties: Record<string, string>; }[]  => {
        if(experience.translations !== undefined) {
            const mergedTranslations = new Map<string, Record<string, string>>();

            for (const translation of experience.translations) {
                if (!translation.locale) continue;

                const locale = translation.locale;
                const properties = translation.properties || {};

                if (mergedTranslations.has(locale)) {
                    mergedTranslations.set(locale, {
                        ...mergedTranslations.get(locale),
                        ...properties
                    });
                } else {
                    mergedTranslations.set(locale, properties);
                }
            }

            return Array.from(mergedTranslations.entries()).map(([locale, properties]) => ({
                locale,
                properties
            }));
        }

        return [];
    }

    return {
        inventoryType: EXPERIENCE,
        id: id as string,
        title: title || '',
        description: description || '',
        coverImage: cover_image ? {
            ...cover_image,
            description: cover_image.description?.map(d => ({ locale: d.locale ?? '', text: d.text ?? '' })) ?? [],
        } : undefined,
        options: getOptions(),
        availabilityType: availability_type === ExperienceResponseAvailabilityTypeEnum.OpeningHours ? 'openingHours' : 'timeSlots',
        latestBookingTime: latest_booking_time_minutes || 0,
        translations: getTranslations(),
        requiresVendorConfirmation: requires_vendor_confirmation ?? false,
        experienceLocation: {
            placeId: location.google_place_id
        },
        bookingRestriction: {
            minParticipants: booking_restrictions?.minimum_participants ?? 0,
            strictMinimumPerBooking: booking_restrictions?.strict_minimum_per_booking ?? false,
        }
    }
};
